import React, {useState} from 'react';

import springboard from 'springboard';

springboard.registerModule('ErrorTesting', {}, async (moduleAPI) => {
    moduleAPI.registerRoute('', {}, () => {
        const [error, setError] = useState('');

        if (error) {
            throw error;
        }

        return (
            <div>
                <button
                    onClick={() => {
                        setError('test render error');
                    }}
                >
                    Render error
                </button>
                <button
                    onClick={() => {
                        throw new Error('test uncaught error');
                    }}
                >
                    Uncaught error
                </button>
            </div>
        );
    });
});
